import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {BulletList} from '../BulletList/BulletList';

import {SkillDetails} from './SkillDetails';
import {JobPosting} from '../../features/company/recruiting/job-postings/types/JobPostingsTypes';

interface Props {
  jobPosting: JobPosting;
}
export const JobPostingBody = ({jobPosting}: Props) => {
  const {t} = useTranslation();
  return (
    <Grid container marginTop={4} columns={12}>
      <Grid item xs={12}>
        <Typography variant='h2' gutterBottom>
          {t('companyJobPostings.jobPostingsAccordion.accordionDetailsBody.aboutThePosition')}
        </Typography>
        <Typography variant='h3' gutterBottom>
          {t('companyJobPostings.newJobDialog.formLabels.responsibilities')}
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <BulletList listItems={jobPosting.responsibilities || []} />
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant='h3'
          sx={{
            margin: '32px 0 16px 0',
          }}
        >
          {t('companyJobPostings.newJobDialog.formLabels.requirements')}
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <BulletList listItems={jobPosting.requirements || []} />
      </Grid>
      <Grid item xs={12}>
        <SkillDetails skills={jobPosting.skills} />
      </Grid>
    </Grid>
  );
};
